module.exports = __webpack_public_path__ + "static/media/estructura.c8cdc876.svg";